module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/venus/venus_sig-29beee6470c230654562e6959e73ad0b.gif";